import { createFileRoute } from '@tanstack/react-router'

import AuthenticatedShell from '@/layouts/AuthenticatedLayout'
import {
    AUTHENTICATED_SESSION_QUERY_KEY,
    systemSettingsQueryOptions,
} from '@/lib/Queries/appQueries.ts'
import { requireAuthenticatedRoute } from '@/lib/Routes/routeGuards.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_authenticated')({
    component: AuthenticatedShell,
    errorComponent: RouteErrorComponent,
    beforeLoad: async function ({ context, location }) {
        const session = await requireAuthenticatedRoute(location.pathname)

        context.queryClient.setQueryData(
            AUTHENTICATED_SESSION_QUERY_KEY,
            session,
        )
        await context.queryClient.ensureQueryData(systemSettingsQueryOptions())
    },
})
